<template>
    <transition v-on:enter="animIn" appear>
        <div :class="{ 'panel': true, 'darken': darken }">
            <slot></slot>
            <div class="button-wrapper">
                <slot name="button"></slot>
            </div>
        </div>
    </transition>
</template>

<style lang="scss" scoped>

</style>

<script>
    import { TimelineMax } from '@/vendor';

    export default {
        props: {
            'darken': {
                type: Boolean,
                default: false
            }
        },

        methods: {
            animIn()
            {
                let tl = new TimelineMax();

                tl.from( this.$el, 0.3, { top: '+=50', opacity: 0 });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/components/Panel.vue